import { render, staticRenderFns } from "./ModalErrorCatalog.vue?vue&type=template&id=444be36e&lang=pug&"
import script from "./ModalErrorCatalog.vue?vue&type=script&lang=js&"
export * from "./ModalErrorCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports